import { RegionsEnum } from 'src/generated/operations.ts';
import { UserSettings } from 'src/types/UserSettings.ts';
import { LocationState } from 'src/sensors/LocationState.ts';
import { Accessory } from 'src/common/prepareAccessories.ts';
import { SensorsAccessoriesPageData } from 'src/sensors/accessories/SensorsAccessoriesPageMapping.ts';
import { prepareSelectionAttributes } from 'src/sensors/checkout/prepareSelectionAttributes.ts';
import { shapeSelectionExportTable } from 'src/projects/utils/shapeSelectionExportTable.ts';

export const prepareSelectionExport = ({
    userSettings,
    locationState,
    isImperial,
    accessories,
    sensor,
} : {
    userSettings: UserSettings;
    locationState: LocationState;
    isImperial: boolean;
    accessories: Accessory<SensorsAccessoriesPageData['accessories']['accessories']['0']>[];
    sensor: SensorsAccessoriesPageData['accessories']['sensor'];
}) => {
    const attr = prepareSelectionAttributes(
        sensor,
        userSettings.currentRegion === RegionsEnum.Am,
        isImperial,
        locationState.selectedFlowRange,
    );

    return shapeSelectionExportTable({
        attr,
        locationState,
        accessories,
        userSettings,
        product: sensor,
    });
};
